import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiBuilder } from './wapi'

export const wapi = () => wapiBuilder({
  httpService: new AxiosHttpServiceBuilder()
})
